import PropTypes from "prop-types";
import { connect } from "react-redux";
import HeadMetadata from "app/utils/metas/HeadMetadata";
import { getRobotsMetaTag } from "app/reducers/partnerSelector";

const MerchandisingListingHeadMetadata = ({
	robotsMetaTag,
	merchandisingLabel,
	titleFromSanity,
	descriptionFromSanity,
}) => {
	const title = titleFromSanity || "page.title.merch";
	const description = descriptionFromSanity || "page.description.merch";

	return (
		<HeadMetadata
			description={description}
			title={title}
			titleAttributes={{
				label: merchandisingLabel,
			}}
			robotsMetaTag={robotsMetaTag}
		/>
	);
};

MerchandisingListingHeadMetadata.propTypes = {
	robotsMetaTag: PropTypes.string,
	merchandisingLabel: PropTypes.string,
	titleFromSanity: PropTypes.string,
	descriptionFromSanity: PropTypes.string,
};

const mapStateToProps = state => {
	const robotsMetaTag = getRobotsMetaTag(state);
	return {
		robotsMetaTag: robotsMetaTag?.merch,
		titleFromSanity: state.brand?.seo?.merch?.metaTitle,
		descriptionFromSanity: state.brand?.seo?.merch?.metaDescription,
	};
};

export default connect(mapStateToProps)(MerchandisingListingHeadMetadata);
